import { ActionTypes } from "../constants/action-types";

export const setToken = (token) =>{
    //  console.log(token);
    return {
        type:ActionTypes.SET_TOKEN,
        payload:token,
    };
};